(function() {
  'use strict';

  if (window.TurbotaCartEnhancementsLoaded) {
    return;
  }
  window.TurbotaCartEnhancementsLoaded = true;

  const CONFIG = {
    freeGiftProperty: '_free_gift',
  };

  const FALLBACK_RULES = [
    { code: '4VR2AA5LS1', variantId: 46162665832721, minimumAmount: 50000 },
    { code: 'UKLON5M9A',  variantId: 52749158383889, minimumAmount: 50000 },
    { code: '4DW9FE2RRG', variantId: 46618720338193, minimumAmount: 60000 },
    { code: 'J4AC1YP9RE', variantId: 48119775068433, minimumAmount: 60000 },
  ];

  // "2026-10-05" = that whole day in the browser's time zone; anything else is
  // parsed as an exact time (ISO from Shopify). Returns ms or null.
  function parseRuleTime(value, endOfDay) {
    const raw = String(value || '').trim();
    if (!raw) return null;
    const day = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (day) {
      const [, y, m, d] = day.map(Number);
      return endOfDay ? new Date(y, m - 1, d, 23, 59, 59, 999).getTime() : new Date(y, m - 1, d).getTime();
    }
    const time = Date.parse(raw);
    return Number.isFinite(time) ? time : null;
  }

  // Scheduled or expired gift codes must not add a product the customer would pay for.
  function isRuleActive(rule, now = Date.now()) {
    if (rule.startsAt && now < rule.startsAt) return false;
    if (rule.endsAt && now > rule.endsAt) return false;
    return true;
  }

  // Manual rules from the "Cart Gift Codes" section in the theme editor.
  function loadManualRules() {
    const node = document.querySelector('[data-cart-gift-rules]');
    if (!node) return [];
    let parsed;
    try {
      parsed = JSON.parse(node.textContent);
    } catch (e) {
      return [];
    }
    return (Array.isArray(parsed) ? parsed : [])
      .filter((r) => r && r.code && r.variantId && r.minimumAmount)
      .map((r) => ({
        code: String(r.code).trim(),
        variantId: Number(r.variantId),
        minimumAmount: Number(r.minimumAmount),
        minimumQuantity: 0,
        startsAt: parseRuleTime(r.startsAt, false),
        endsAt: parseRuleTime(r.endsAt, true),
        label: r.label || '',
      }))
      .filter((r) => r.code && r.variantId && r.minimumAmount);
  }

  // Product promo codes synced from Shopify discounts (tools/promo-gifts-sync.py →
  // shop metafield turbota.promo_gifts → sections/promo-gifts.liquid). Fetched only
  // when a code is entered, so new gift codes work without touching the theme.
  let syncedRulesPromise = null;
  function loadSyncedRules() {
    if (!syncedRulesPromise) {
      const root = window.Shopify?.routes?.root || '/';
      syncedRulesPromise = fetch(`${root}?sections=promo-gifts`, { headers: { Accept: 'application/json' } })
        .then((response) => (response.ok ? response.json() : {}))
        .then((payload) => {
          const html = payload?.['promo-gifts'];
          if (!html) return [];
          const node = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-promo-gifts]');
          const parsed = JSON.parse(node?.textContent || '[]');
          return Array.isArray(parsed) ? parsed : [];
        })
        .catch(() => {
          syncedRulesPromise = null;
          return [];
        });
    }
    return syncedRulesPromise;
  }

  async function findSyncedRule(code) {
    const upper = String(code || '').toUpperCase();
    const rules = await loadSyncedRules();
    const rule = rules.find((r) => Array.isArray(r?.codes) && r.codes.includes(upper));
    if (!rule || !rule.variantId) return null;
    const parsed = {
      code: upper,
      variantId: Number(rule.variantId),
      minimumAmount: Number(rule.minimumAmount) || 0,
      minimumQuantity: Number(rule.minimumQuantity) || 0,
      startsAt: parseRuleTime(rule.startsAt, false),
      endsAt: parseRuleTime(rule.endsAt, true),
    };
    return isRuleActive(parsed) ? parsed : null;
  }

  // Manual editor rules win (explicit choice), then synced Shopify discounts,
  // then the hardcoded fallback list.
  async function findGiftRule(code) {
    return findRuleForCode(code, MANUAL_RULES)
      || (await findSyncedRule(code))
      || findRuleForCode(code, FALLBACK_RULES);
  }

  function findRuleForCode(code, rules) {
    const upper = String(code || '').toUpperCase();
    if (!upper) return null;
    for (let i = 0; i < rules.length; i++) {
      const rule = rules[i];
      if (!isRuleActive(rule)) continue;
      const raw = String(rule.code || '').trim();
      if (!raw) continue;
      const lower = raw.toLowerCase();
      if (lower.indexOf('prefix:') === 0) {
        const prefix = raw.slice(7).trim().toUpperCase();
        if (prefix && upper.indexOf(prefix) === 0) return rule;
      } else if (lower.indexOf('regex:') === 0) {
        const pattern = raw.slice(6).trim();
        if (!pattern) continue;
        try {
          if (new RegExp(pattern, 'i').test(code)) return rule;
        } catch (e) { /* invalid regex, skip */ }
      } else if (raw.toUpperCase() === upper) {
        return rule;
      }
    }
    return null;
  }

  const MANUAL_RULES = loadManualRules();

  function setMessage(form, message, isError = false) {
    const node = form.querySelector('[data-cart-promo-message]');
    if (!node) return;
    node.hidden = !message;
    node.textContent = message || '';
    node.classList.toggle('is-error', Boolean(message && isError));
    node.classList.toggle('is-success', Boolean(message && !isError));
  }

  async function fetchCart() {
    const response = await fetch('/cart.js', {
      headers: {
        Accept: 'application/json',
      },
    });
    if (!response.ok) {
      throw new Error('Не вдалося прочитати кошик.');
    }
    return response.json();
  }

  function hasGiftInCart(cart, variantId) {
    return (cart.items || []).some((item) => item.variant_id === variantId || item.properties?.[CONFIG.freeGiftProperty]);
  }

  function itemCountWithoutGift(cart, variantId) {
    return (cart.items || []).reduce((count, item) => {
      if (item.variant_id === variantId || item.properties?.[CONFIG.freeGiftProperty]) {
        return count;
      }
      return count + item.quantity;
    }, 0);
  }

  function subtotalWithoutGift(cart, variantId) {
    return (cart.items || []).reduce((total, item) => {
      if (item.variant_id === variantId || item.properties?.[CONFIG.freeGiftProperty]) {
        return total;
      }
      return total + item.final_line_price;
    }, 0);
  }

  async function addGiftVariant(rule) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [{
          id: rule.variantId,
          quantity: 1,
          properties: {
            [CONFIG.freeGiftProperty]: 'true',
            _gift_message: 'Безкоштовний подарунок',
            // Conditions of this gift's code, used to drop it when the cart shrinks.
            _gift_min: String(rule.minimumAmount || 0),
            _gift_min_qty: String(rule.minimumQuantity || 0),
            ...(rule.endsAt ? { _gift_until: String(rule.endsAt) } : {}),
          },
        }],
      }),
    });

    if (!response.ok) {
      let message = 'Не вдалося додати подарунок у кошик.';
      try {
        const payload = await response.json();
        if (payload?.description) {
          message = payload.description;
        } else if (payload?.message) {
          message = payload.message;
        }
      } catch (error) {
        // Keep the fallback copy when Shopify returns a non-JSON error.
      }
      throw new Error(message);
    }

    return response.json();
  }

  async function applyDiscountCode(code) {
    const response = await fetch(`/discount/${encodeURIComponent(code)}?redirect=/cart`, {
      method: 'GET',
      credentials: 'same-origin',
    });

    if (!response.ok) {
      throw new Error('Не вдалося застосувати промокод.');
    }
  }

  async function removeDiscountCodes() {
    const response = await fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        discount: '',
      }),
    });

    if (!response.ok) {
      throw new Error('Не вдалося прибрати промокод.');
    }

    return response.json();
  }

  async function removeGiftItems(cart, shouldRemove) {
    const giftItems = (cart.items || [])
      .map((item, index) => ({ item, line: index + 1 }))
      .filter(({ item }) => item.properties?.[CONFIG.freeGiftProperty])
      .filter(({ item }) => !shouldRemove || shouldRemove(item));

    for (const entry of giftItems.reverse()) {
      await fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          line: entry.line,
          quantity: 0,
        }),
      });
    }
  }

  function refreshCartUi() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  async function syncGiftEligibility() {
    const cart = await fetchCart();
    const hasGiftItems = (cart.items || []).some((item) => item.properties?.[CONFIG.freeGiftProperty]);
    if (!hasGiftItems) return;

    const regularItems = (cart.items || []).filter((item) => !item.properties?.[CONFIG.freeGiftProperty]);
    const subtotalExcludingGifts = regularItems.reduce((total, item) => total + item.final_line_price, 0);
    const countExcludingGifts = regularItems.reduce((count, item) => count + item.quantity, 0);

    // Gifts added before per-gift conditions existed: smallest known manual minimum.
    const legacyMinimums = MANUAL_RULES.concat(FALLBACK_RULES)
      .map((rule) => rule.minimumAmount)
      .filter((n) => Number.isFinite(n) && n > 0);
    const legacyMinimum = legacyMinimums.length ? Math.min(...legacyMinimums) : 0;

    const noLongerEligible = (item) => {
      const props = item.properties || {};
      if (!props[CONFIG.freeGiftProperty]) return false;
      if (props._gift_min === undefined) {
        return legacyMinimum > 0 && subtotalExcludingGifts < legacyMinimum;
      }
      if (props._gift_until && Date.now() > Number(props._gift_until)) return true;
      const minAmount = Number(props._gift_min) || 0;
      const minQty = Math.max(Number(props._gift_min_qty) || 0, 1);
      return subtotalExcludingGifts < minAmount || countExcludingGifts < minQty;
    };

    if (!(cart.items || []).some(noLongerEligible)) return;

    await removeGiftItems(cart, noLongerEligible);
    refreshCartUi();
  }

  async function handlePromoSubmit(form) {
    const input = form.querySelector('[name="discount_code"]');
    const button = form.querySelector('[type="submit"]');
    const code = String(input?.value || '').trim().toUpperCase();

    if (!code) {
      setMessage(form, 'Введи промокод.', true);
      return;
    }

    button?.setAttribute('disabled', 'disabled');
    setMessage(form, '');

    try {
      const giftConfig = await findGiftRule(code);
      if (giftConfig) {
        const cart = await fetchCart();
        const hasGift = hasGiftInCart(cart, giftConfig.variantId);
        const eligibleSubtotal = subtotalWithoutGift(cart, giftConfig.variantId);
        const eligibleCount = itemCountWithoutGift(cart, giftConfig.variantId);

        if (!hasGift && eligibleSubtotal < giftConfig.minimumAmount) {
          throw new Error(`Для цього промокоду сума кошика має бути від ${Math.round(giftConfig.minimumAmount / 100)} грн.`);
        }

        const minimumQuantity = Math.max(giftConfig.minimumQuantity || 0, 1);
        if (!hasGift && eligibleCount < minimumQuantity) {
          throw new Error(minimumQuantity > 1
            ? `Для цього промокоду додай у кошик щонайменше ${minimumQuantity} шт. товару.`
            : 'Спершу додай у кошик товар, а потім введи промокод.');
        }

        if (!hasGift) {
          await addGiftVariant(giftConfig);
        }
      }

      await applyDiscountCode(code);
      setMessage(form, 'Промокод застосовано.');
      if (input) {
        input.value = '';
      }
      refreshCartUi();
    } catch (error) {
      setMessage(form, error.message || 'Не вдалося застосувати промокод.', true);
    } finally {
      button?.removeAttribute('disabled');
    }
  }

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-cart-promo-form]');
    if (!form) return;

    event.preventDefault();
    handlePromoSubmit(form);
  });

  document.addEventListener('click', async(event) => {
    const button = event.target.closest('[data-cart-discount-remove]');
    if (!button) return;

    event.preventDefault();
    const form = button.closest('[data-cart-promo]');
    try {
      const cart = await fetchCart();
      await removeGiftItems(cart);
      await removeDiscountCodes();
      setMessage(form, 'Промокод прибрано.');
      refreshCartUi();
    } catch (error) {
      setMessage(form, error.message || 'Не вдалося прибрати промокод.', true);
    }
  });

  document.addEventListener('cart:refresh', () => {
    syncGiftEligibility().catch(() => {});
  });

  window.addEventListener('load', () => {
    syncGiftEligibility().catch(() => {});
  });
})();
